import { useMemo, useState } from "react";
import { SubAssembly, LandingGearTypeFilter } from "../../../../types/subAssembly";

export function useSubAssemblyFilter(subAssemblies: SubAssembly[]) {
  const [filter, setFilter] = useState<LandingGearTypeFilter>("All");

  const filteredSubAssemblies = useMemo(() => {
    if (filter === "All") return subAssemblies;
    return subAssemblies.filter(
      (item) => item.landingGearType?.toUpperCase() === filter.toUpperCase()
    );
  }, [filter, subAssemblies]);

  return {
    filter,
    setFilter,
    filteredSubAssemblies,
  };
}
